export const i18n = {
  SHOW_MORE: "表示を拡大",
  SHOW_LESS: "表示を縮小",
  CLEAR: "Clear",
  FILTER_SEARCH_RESULTS: "Filter search results",
  RESET_FILTERS: "Reset filters",
};
